var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { State } from "../../../hooks/useUseCase";
import { OpenedPmlAssignmentSelectDialogPayload } from "./usecases/OpenPmlAssignmentSelectDialogUseCase";
import { SelectedPmlCoursePayload } from "./usecases/SelectPmlAssignmentUseCase";
import { ClosedPmlAssignmentSelectDialogPayload } from "./usecases/ClosePmlAssignmentSelectDialogUseCase";
import { createSelectedPmlCourse } from "../models/SelectedPmlCourse";
import { StartedLoadingPayload } from "./usecases/payload/StartedLoadingPayload";
import { FinishedLoadingPayload } from "./usecases/payload/FinishedLoadingPayload";
import { FetchedPmlAssignmentInfoPayload } from "./usecases/FetchPmlCourseInfoUseCase";
import { PmlCourseInfo } from "../models/PmlCourseInfo";
import { getThumbnailPath } from "./helpers/thumbnail-helper";
var PmlAssignmentSelectDialogState = /** @class */ (function (_super) {
    __extends(PmlAssignmentSelectDialogState, _super);
    function PmlAssignmentSelectDialogState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pmlCourseAssignmentInfo = {
            courses: [],
        };
        _this.selectedPmlCourse = createSelectedPmlCourse();
        _this.isLoading = false;
        return _this;
    }
    Object.defineProperty(PmlAssignmentSelectDialogState.prototype, "selectedPmlCourseId", {
        get: function () {
            var _a;
            return (_a = this.selectedPmlCourse.course) === null || _a === void 0 ? void 0 : _a.id;
        },
        enumerable: false,
        configurable: true
    });
    PmlAssignmentSelectDialogState.prototype.reduce = function (payload) {
        var _this = this;
        if (payload instanceof FetchedPmlAssignmentInfoPayload) {
            this.pmlCourseAssignmentInfo = payload.courseInfo;
            this.isLoading = false;
        }
        if (payload instanceof OpenedPmlAssignmentSelectDialogPayload) {
            this.selectedPmlCourse = createSelectedPmlCourse();
            if (payload.defaultPmlCourse) {
                // defaultPmlCourseにはidしか入っていないため、取得した課題情報から足りない情報を補完する。
                var pmlCourseInfo = (function () {
                    var targetGroup = _this.pmlCourseAssignmentInfo.courses
                        .flatMap(function (course) { return course.groups; })
                        .find(function (group) { var _a; return group.groupId === ((_a = payload.defaultPmlCourse) === null || _a === void 0 ? void 0 : _a.id); });
                    if (targetGroup) {
                        return new PmlCourseInfo({
                            id: targetGroup.groupId,
                            title: targetGroup.groupTitle,
                            thumbnail: getThumbnailPath(payload.kind, targetGroup.groupId, targetGroup.thumbnail),
                        });
                    }
                    var targetStage = _this.pmlCourseAssignmentInfo.courses
                        .flatMap(function (course) { return course.groups.flatMap(function (group) { return group.stages; }); })
                        .find(function (stage) { var _a; return stage.id === ((_a = payload.defaultPmlCourse) === null || _a === void 0 ? void 0 : _a.id); });
                    if (targetStage) {
                        var thumbnail = getThumbnailPath(payload.kind, targetStage.id, targetStage.thumbnail);
                        return new PmlCourseInfo(__assign(__assign({}, targetStage), { thumbnail: thumbnail }));
                    }
                })();
                this.selectedPmlCourse.select(pmlCourseInfo);
            }
        }
        if (payload instanceof SelectedPmlCoursePayload) {
            this.selectedPmlCourse.select(payload.course);
        }
        if (payload instanceof ClosedPmlAssignmentSelectDialogPayload) {
            this.selectedPmlCourse.clear();
        }
        if (payload instanceof StartedLoadingPayload) {
            this.isLoading = true;
        }
        if (payload instanceof FinishedLoadingPayload) {
            this.isLoading = false;
        }
    };
    return PmlAssignmentSelectDialogState;
}(State));
export { PmlAssignmentSelectDialogState };
export var initialPmlSelectDialogState = new PmlAssignmentSelectDialogState();
